import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineCurrencyDollar, HiX } from "react-icons/hi";

export interface ProductPriceBannersProps {
  kilometerPrice: number;
  kilometerPriceVat: number;
  onRemoveKilometerPrice: () => void;
  timePrice: number;
  timePriceVat: number;
  timePeriodInMinutes: number;
  onRemoveTimePrice: () => void;
}

export const ProductPriceBanners: FC<ProductPriceBannersProps> = ({
  kilometerPrice,
  kilometerPriceVat,
  onRemoveKilometerPrice,
  timePrice,
  timePriceVat,
  timePeriodInMinutes,
  onRemoveTimePrice,
}) => {
  const { t } = useTranslation(["common"]);

  return (
    <>
      {/* Kilometerpris Active Banner - Updated Icon */}
      {kilometerPrice > 0 && (
        <div className="mb-4 p-3 bg-warning-muted dark:bg-warning-muted rounded-lg border border-warning dark:border-warning flex items-center justify-between text-lgb-yellow-800 text-sm">
          <div className="flex items-center">
            <HiOutlineCurrencyDollar className="mr-2 h-5 w-5 flex-shrink-0" />
            <span>
              {t("common:kilometer_price_active", "Kilometerpris aktivert:")}{" "}
              <span className="font-medium text-lgb-yellow-900">
                {kilometerPrice} kr
              </span>{" "}
              {t("common:per_kilometer", "per kilometer")}
              {", "}
              {t("common:plus_vat", "pluss")}{" "}
              <span className="font-medium text-lgb-yellow-900">
                {kilometerPriceVat}%
              </span>{" "}
              {t("common:vat", "MVA")}
            </span>
          </div>
          <button
            onClick={onRemoveKilometerPrice}
            className="ml-2 text-warning-contrast hover:text-lgb-yellow-900 dark:text-lgb-yellow-700 dark:hover:text-lgb-yellow-900"
            aria-label={t("common:remove", "Fjern")}
          >
            <HiX className="h-5 w-5" />
          </button>
        </div>
      )}

      {/* Tidspris Active Banner */}

      {timePrice > 0 && (
        <div className="mb-4 p-3 bg-brand-muted dark:bg-brand-muted rounded-lg border border-brand dark:border-brand flex items-center justify-between text-lgb-blue-800 text-sm">
          <div className="flex items-center">
            <HiOutlineCurrencyDollar className="mr-2 h-5 w-5 flex-shrink-0" />
            <span>
              {t("common:time_price_active", "Tidspris aktivert:")}{" "}
              <span className="font-medium text-lgb-blue-900">
                {timePrice} kr
              </span>{" "}
              {t("common:per_time_period", "per")} {timePeriodInMinutes}{" "}
              {t("common:minutes", "minutter")}
              {", "}
              {t("common:plus_vat", "pluss")}{" "}
              <span className="font-medium text-lgb-blue-900">
                {timePriceVat}%
              </span>{" "}
              {t("common:vat", "MVA")}
            </span>
          </div>
          <button
            onClick={onRemoveTimePrice}
            className="ml-2 text-lgb-blue-600 hover:text-lgb-blue-900 dark:text-lgb-blue-700 dark:hover:text-lgb-blue-900"
            aria-label={t("common:remove", "Fjern")}
          >
            <HiX className="h-5 w-5" />
          </button>
        </div>
      )}
    </>
  );
};
